import { default as term } from './term/services'
import { default as signature } from  './signature/services'
import { default as term_tag } from  './term_tag/services'
import { default as term_option } from  './term_option/services'

export default {
    ...term,
    ...signature,
    ...term_tag,
    ...term_option,
}